module.exports = __webpack_public_path__ + "static/img/major_pictgrid14_800x800.258c6e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/major_pictgrid14_800x800.jpg
// module id = P9x4
// module chunks = 0